import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { trackById } from '@core/utils/utils';
import { ProExperience } from '@models/profile/pro-experience';

@Component({
  selector: 'profile-pro-experiences',
  templateUrl: './pro-experiences.component.html',
  styleUrls: ['./pro-experiences.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProExperiencesComponent {
  @Input() model: ProExperience[];

  loadingItem: ProExperience;
  trackById = trackById;
}
